import React from 'react';

const SvgTurnleft = props => (
  <svg width="1em" height="1em" viewBox="0 0 1024 1024" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M511.833 183.467V64l-268.8 149.333 268.8 149.334V243.2c197.12 0 358.4 149.333 358.4 334.507v143.36h59.734v-143.36c0-218.027-188.16-394.24-418.134-394.24z" />
      <path d="M631.3 482.133H153.433c-32.853 0-59.733 26.88-59.733 59.734v358.4C93.7 933.12 120.58 960 153.433 960H631.3c32.853 0 59.733-26.88 59.733-59.733v-358.4c0-32.854-26.88-59.734-59.733-59.734zm0 418.134H153.433v-358.4H631.3v358.4z" />
    </g>
  </svg>
);

export default SvgTurnleft;
